declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

// Trimmed at the single read: the Vercel value has carried a trailing newline,
// which is fatal when interpolated into the inline init script.
export const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID?.trim();

export function generateEventId(eventName: string): string {
  // crypto.randomUUID is collision-free; Date.now/Math.random could collide on
  // two submits in the same ms. Requires a secure context — met on https + localhost.
  return `${eventName}_${crypto.randomUUID()}`;
}

export function pageview() {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", "PageView");
  }
}

export function trackEvent(name: string, options?: Record<string, unknown>, eventId?: string) {
  if (typeof window !== "undefined" && window.fbq) {
    window.fbq("track", name, options, eventId ? { eventID: eventId } : undefined);
  }
}
